<script lang="ts">
  import { m } from "#messages";
  import { WORDMARK } from "./brand.generated.ts";

  let { height = 14 }: { height?: number } = $props();
</script>

<svg
  role="img"
  aria-label={m.app_name()}
  {height}
  width={height * WORDMARK.ratio}
  viewBox={WORDMARK.viewBox}
  class="shrink-0"
  fill="currentColor"
>
  {#each WORDMARK.letters as letter (letter.x)}
    <path d={letter.d} transform="translate({letter.x} 0)" />
  {/each}
</svg>
